import React, { useMemo } from 'react';

import { MenuIcon } from 'lucide-react';

import { Button } from '@/components/shadcn/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/ui/popover';
import { Currency } from '@/constants';
import useBuildInfoStore from '@/hooks/useBuildInfo';

import { BuildDetailsCopyIdsByTokens } from '../components/BuildDetailsCopyL1IdsByTokens';

interface BuildDetailsChainTokenInfoActionsProps {
  tokensByChain: Currency[];
}

export const BuildDetailsChainTokenInfoActions: React.FC<BuildDetailsChainTokenInfoActionsProps> = ({
  tokensByChain,
}) => {
  const { buildInfo } = useBuildInfoStore();

  const l1BaseIdsByTokens = useMemo(() => {
    return tokensByChain
      .map((currency) => {
        if (!buildInfo?.[currency]?.L1_CONTRACT_ADDRESS_BASE) {
          return null;
        }

        return (buildInfo?.[currency]?.L1_CONTRACT_ADDRESS_BASE as { id: string })?.id;
      })
      .filter(Boolean) as string[];
  }, [tokensByChain, buildInfo?.build]);

  const l1MakerIdsByTokens = useMemo(() => {
    return tokensByChain
      .map((currency) => {
        if (!buildInfo?.[currency]?.L1_CONTRACT_ADDRESS_MAKER) {
          return null;
        }

        return (buildInfo?.[currency]?.L1_CONTRACT_ADDRESS_MAKER as { id: string })?.id;
      })
      .filter(Boolean) as string[];
  }, [tokensByChain, buildInfo?.build]);

  if (l1BaseIdsByTokens.length === 0 && l1MakerIdsByTokens.length === 0) {
    return null;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          onClick={(e) => {
            e.stopPropagation();
          }}
          variant="secondary"
          className="h-auto px-1 py-0.5"
        >
          <MenuIcon className="size-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="flex flex-col gap-2 p-2">
        {l1BaseIdsByTokens.length > 0 && <BuildDetailsCopyIdsByTokens tokenIds={l1BaseIdsByTokens} title="L1BaseIds" />}
        {l1MakerIdsByTokens.length > 0 && (
          <BuildDetailsCopyIdsByTokens tokenIds={l1MakerIdsByTokens} title="L1MakerIds" />
        )}
      </PopoverContent>
    </Popover>
  );
};
